module.exports = __webpack_public_path__ + "assets/img/2258-ax.svg";